import { Pipe, PipeTransform } from '@angular/core';
import { HumanReadableInteger } from './human-readable-integer';
import { Language } from './language';

@Pipe({
  name: 'readableNumber'
})
export class ReadableNumberPipe implements PipeTransform {

  transform(value: number, lang: Language = Language.Persian): unknown {
    return new HumanReadableInteger().NumberToText(value, lang);
  }

}
